import axios from "axios";
import React, { useLayoutEffect, useState } from "react";
import { Redirect, Route, useHistory } from "react-router-dom";
import swal from "sweetalert";
import MasterLayout from "../../layout/admin/MasterLayout";
const AddminPrivateRoute = ({ ...rest }) => {

    const history = useHistory();
    const [Authenticated, setAuthenticated] = useState(false);
    const [looding, setLooding] = useState(true);

    useLayoutEffect(() => {
        axios.get(`/api/checkingAuthenticated`).then(res => {
            if (res && res.status === 200) {
                setAuthenticated(true);
            }
            setLooding(false);
        })
        return () => {
            setAuthenticated(false);
        }
    }, [])

    axios.interceptors.response.use('undefined', function axiosRetryIntercepter(err) {
        if (err.response.status === 401) {
            swal("Unauthorized", err.response.data.message, "warning");
            history.push('/login');
        }
       return Promise.reject(err);
    })

    axios.interceptors.response.use(function (response) {
        
        return response;

    }, function(error) {
        if(error.response.status === 403){ // access denied
            swal("Forbedden", error.response.data.message, "warning");
            history.push("/page403")
        } else if(error.response.status === 404){ // page not found
            swal("404 Page Error", "Oops page not found", "warning");
            history.push("/page404")
        }
        
        return  Promise.reject(error);
    });

    if (looding) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;

    }

    return (
        <Route {...rest}
            render={({ props, location }) =>
                Authenticated ?
                    (<MasterLayout {...props} />) :
                    (<Redirect to={{ pathname: "/login", state: { from: location } }} />)
            }

        />
    );

}

export default AddminPrivateRoute;